import _extends from '@babel/runtime/helpers/esm/extends';
import React from 'react';
import GrowRight from '@elliemae/ds-shared/Animations/GrowRight';

var ToolBarAnimation = function ToolBarAnimation(props) {
  return /*#__PURE__*/React.createElement(GrowRight, _extends({}, props, {
    key: "popper-animation-key",
    from: 0.5,
    to: 1
  }));
};

export { ToolBarAnimation };
//# sourceMappingURL=ToolBarAnimation.js.map
